angular.module('cfn').filter('unitToString', [
  'unitConverter',
  function(unitConverter) {
    'use strict';

    return function(enumValue, enumType) {
      //enums are defined in the global scope
      var unitString = enums[enumType][enumValue];
      if (_.isUndefined(unitString) && unitConverter.isRatio(enumValue)) {
        var unitParts = unitConverter.splitRatio(enumValue);
        return (
          enums.UnitsCapacityEnum[unitParts.numerator] +
          '/' +
          enums.UnitsCapacityEnum[unitParts.denominator]
        );
      }

      return unitString;
    };
  }
]);
